
import { Options } from "vue-class-component";

import { TreeSelect, Tag, List, Search, Icon } from "vant";
import MyTabbar from "@/components/Tabbar.vue";
import BaseList from "@/common/BaseList";
import ServeItem from "@/components/item/ServeItem.vue";
import PackageItem from "@/components/item/PackageItem.vue";
import AppUtil from "@/util/AppUtil";

@Options({
  components: {
    [Icon.name]: Icon,
    [Search.name]: Search,
    [List.name]: List,
    [TreeSelect.name]: TreeSelect,
    [Tag.name]: Tag,
    Tabbar: MyTabbar,
    "serve-item": ServeItem,
    "pack-item": PackageItem,
  },
})
export default class ServeList extends BaseList {
  /**项呈示器对象 */
  currentItem = "serve-item";
  cartImg = require("../../assets/cart.png");
  /**是否显示购物车图标 */
  showCart = true;
  /**左边导航栏索引 */
  navIdx = 0;
  /**二级分类索引 */
  sortIdx = 0;
  /**
   *@description 请求列表的地址
   */
  protected reqUrl = "/zhServe/serve/getServeList";
  /** 防止触发加载*/
  finished = true;
  backcolor = "white";
  text = "";
  /**分类导航*/
  public get sortList(): {
    id: number;
    text: string;
    sortName: string;
    childrenList: any[];
  }[] {
    return this.appVo.serveSortList;
  }
  cart_click(){
this.$router.push({ name: 'ServeCarts' })
  }
  // 
  protected init_item(val: any) {

    val.thumb = this.get_thumb(val.serveLogo, 250, 325);
    val.goodsDesc = ""; //商品简略描述
    val.registerNum = val.registerNum || 0; //已约次数

    val.goodsList.map((good: any) => {
      // console.log("good",good);
      val.goodsDesc += good.goodsName + "*" + good.goodsNum + ";";
    });
    if(val.limitNum<0){
val.limitNum="不限"
    }
    return val;
  }
  mounted() {
    // console.log("serveSortList",this.appVo.serveSortList);

    // this.req_userInfo(this.check_sortList);
    this.check_sortList();
  }
  protected item_click(item: any, index: number) {
    // console.log("item_click",item,index)
    // this.$router.push({
    //     name: 'StaffDetail'
    // })
    this.$router.push({
      name: "ServeDetail",
      query: { id: item.id },
    });
  }

  private nav_change(index: number) {
    this.navIdx = index;
    this.sort_change(0);
    // console.log("nav_change",index)
  }
  /* 检测是否需要请求分类数据*/
  private check_sortList() {
    this.sortList.length ? this.req_serveList() : this.req_sortList();
  }
  /*重新请求数据 */
  protected req_serveList() {
    // console.log("req_serveList",this.navIdx);
    
    let sortArr = this.sortList[this.navIdx].childrenList;
    this.reqData.sortOneId = this.sortList[this.navIdx].id||"";
    // sortArr&&sortArr[this.sortIdx].id
    //   ? (this.reqData.sortTwoId = sortArr[this.sortIdx].id)
    //   :"";
    if(sortArr){
      this.reqData.sortTwoId = sortArr[this.sortIdx].id||"";
   
    }
     
    this.reqData.page = 0;
    this.list = [];
    // this.finished = true;
    this.req_items();
  }
  private sort_change(index: number) {
    this.sortIdx = index;
    this.req_serveList();
  }
  req_sortList() {
    AppUtil.request(
      {
        url: "/zhServe/serve/getServeSortList",
        method: "post",
      },
      (res: any) => {
        this.appVo.serveSortList = res.data;
        this.req_serveList();
      },
      "获取服务信息..."
    );
  }
}
